export { default } from './elementAcceptingRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/elementAcceptingRef/index.js
// module id = 166
// module chunks = 25